import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Alert, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import './ErrorState.scss'
const ErrorState = memo(({ error, onRetry }) => {
  const { t } = useTranslation()

  return (
    <div className="ai-credit-error-state" role="alert" aria-live="assertive">
      <Alert
        message={t('reports:error_loading_data') || 'Error Loading Data'}
        description={error || t('reports:something_went_wrong') || 'Something went wrong. Please try again.'}
        type="error"
        showIcon
        action={
          onRetry && (
            <Button
              size="small"
              danger
              onClick={onRetry}
              aria-label="Retry loading data"
            >
              {t('buttons:retry') || 'Retry'}
            </Button>
          )
        }
      />
    </div>
  )
})

ErrorState.propTypes = {
  error: PropTypes.string,
  onRetry: PropTypes.func
}

ErrorState.displayName = 'ErrorState'

export default ErrorState
